/**
 * Locks an Object so that it's properties cannot
 * be overwritten.
 *
 * Properties can be excluded by placing
 * them in the 'exclude' object with value 'false'
 *
 * { toExclude: false }
 *
 * @param obj
 * @param exclude
 */
export function lockObject(obj, exclude = null) {
	for (let key in obj) {
		//@ts-ignore
		if (Array.isArray(exclude) && (exclude.indexOf(key) >= 0)) continue;
		lockObjectProperty(obj, key);
	}
}

/**
 * Locks and Object's given property.
 *
 * @param obj
 * @param property
 */
export function lockObjectProperty(obj, property) {
	const desc = Object.getOwnPropertyDescriptor(obj, property);
	if (desc) {
		let config = {
			configurable: false,
			enumerable: false
		};
		desc.get && (config["get"] = desc.get);
		desc.set && (config["set"] = desc.set);
		!desc.get && !desc.set && (config["writable"] = false);
		Object.defineProperty(obj, property, config);
	} else {
		console.warn("lockObjectProperty", property, "does not have descriptor");
	}
}

/**
 * Another implementation of Object.assign that also copies accessor
 * definitions rather than the value
 *
 * @param target {Object}
 * @param sources {Object}
 * @returns {Object}
 */
export function completeAssign(target: Object) {
	// IE does not support the spread operator (...) so we fetch any extra arguments here
	//@ts-ignore
	let sources: Object[] = arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments);
	sources.shift();

	sources && sources.forEach(function (source) {
		if (!source)
			return;

		let descriptors = Object.keys(source).reduce(function (descriptors, key) {
			descriptors[key] = Object.getOwnPropertyDescriptor(source, key);
			return descriptors;
		}, {});

		// by default, Object.assign copies enumerable Symbols too
		if (Object.getOwnPropertySymbols) {
			Object.getOwnPropertySymbols(source).forEach(function (sym) {
				let descriptor = Object.getOwnPropertyDescriptor(source, sym);
				if (descriptor && descriptor.enumerable) {
					descriptors[sym] = descriptor;
				}
			}
			);
		}

		Object.defineProperties(target, descriptors);
	});
	return target;
}

export function fromEntries(iterable: Iterable<any>) {
	return [...iterable].reduce((obj, [key, val]) => {
		obj[key] = val
		return obj
	}, {})
}

export function isValidDate(d: any) {
	//@ts-ignore
	return d instanceof Date && !isNaN(d);
}